import { Body, Bold, classNames, TruncateText } from '@panwds/react-ui'
import { CaretRightIcon } from '@panwds/icons'
import { useCallback, useContext } from 'react'
import AppImage from '../../../common/components/appName/AppImage'
import { APP_ID_PRISMA_ACCESS_EDITION, APP_ID_SDWAN } from '../../../common/constants/GlobalConstants'
import AppContext from '../../../common/context/AppContext'

/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on GroupByColumnRenderer.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */


const GroupByColumnRenderer = ({ row, value, showSubRows, toggleClick }) => {
  const { getAppName } = useContext(AppContext)

  let cssName = row.original.is_primary || row.original.is_header ? 'tw-text-blue-600 tw-truncate' : 'tw-text-blue-600 tw-truncate tw-ml-4'
  cssName = row.original.is_header ? `${cssName} tw-pt-2` : cssName

  const getDisplayName = useCallback(() => {
    if (row.original.is_header || row.original.is_primary) {
      return value
    }
    else if (row.original.app_id !== APP_ID_PRISMA_ACCESS_EDITION && row.original.app_id !== APP_ID_SDWAN) {
      return getAppName(row.original.app_id, value)
    }
    else {
      return value
    }

  }, [getAppName, row.original.app_id, row.original.is_header, row.original.is_primary, value])

  return (
    <>
      {(row.original.is_primary || row.original.is_header || showSubRows) &&
      <li className='tw-relative tw-h-full tw-truncate' style={{ minHeight: '3rem' }}>
        <div
          className={`tw-flex tw-flex-row tw-border tw-truncate tw-border-indigo-500 tw-border-b-4 ${row.original.is_collapsed ? 'tw-cursor-pointer' : 'tw-cursor-auto'}`}>
          {row.original.is_primary && <CaretRightIcon
            size='sm'
            onClick={toggleClick.bind(this, row.original)}
            className={classNames('tw-text-gray-600 tw-transition-transform tw-duration-200 tw-px-1', !row.original.is_collapsed && 'cm-rotate-90')}/>}
          {row.original.is_header &&
          <AppImage style={{ width: '24px', height: '24px' }} app_id={row.original.image_name} alt="Prisma Access"/>}
          <TruncateText style={{ width: '95%' }}>
            <Body size='sm' truncate={true}
              addClassName={cssName}><Bold truncate="true">{getDisplayName()}</Bold></Body>
          </TruncateText>
        </div>
      </li>
      }
    </>
  )
}

export default GroupByColumnRenderer
